import { useAtom } from 'jotai';
import * as React from 'react';

import { installAppStateAtom } from 'common/state/installAppState';

export function useCaptureBeforeInstallEvent() {
  const [{ bipEvent, installAttempted }, setAppInstallState] = useAtom(installAppStateAtom);
  // save the prompt event to re-use in the install button
  React.useEffect(() => {
    const handler = ((ev: BeforeInstallPromptEvent) => {
      ev.preventDefault();
      setAppInstallState({ bipEvent: ev, installAttempted });
    }) as EventListenerOrEventListenerObject;

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, [setAppInstallState, bipEvent, installAttempted]);
}
